import React from 'react'
import PropTypes from 'prop-types'
// import moment from 'moment'
import R from 'ramda'
import {
  Label,
  Form,
  Button
} from 'semantic-ui-react'

import {
  AUTH_API_URL
} from '_constants'

import {
  escapeRE
  // getPageData
} from '_utils'

// import LineItem from '_views/lineItem'
import SuggestionItem from '_views/suggestionItem'
import SuggestionItems from '_views/suggestionItems'
import AutoComplete from '_views/autocomplete/url'
import {sendPost} from './sendRequest'

const getAcUrl = term => `${AUTH_API_URL}/institutions/?query=${term}`
const getNote = R.prop('note')
const getNotes = R.compose(
  R.defaultTo([]),
  R.prop('notes')
)
const formatSelection = institution => {
  const _id = R.prop('_id', institution)
  const name = R.prop('name', institution)
  const contactEmail = R.prop('contact_email', institution)
  const contactName = R.prop('contact_name', institution)
  return (
    <Label style={{display: 'inline-block'}} key={'sel_' + _id}>
      <div>{ name }</div>
      <div>{ contactName }</div>
      <div>{ contactEmail }</div>
      <div><small>{ _id }</small></div>
    </Label>
  )
}

const formatSuggestion = (institution, term) => {
  const tReg = {
    regex: new RegExp(escapeRE(term), 'i'),
    term
  }
  return (
    <div key={'sug_' + institution._id} >
      <SuggestionItem label='name' text={institution.name} tReg={tReg} always={true} />
      <SuggestionItem label='id' text={institution._id} tReg={tReg} />
      <SuggestionItem label='contact name' text={institution.contact_name} tReg={tReg} always={true} />
      <SuggestionItem label='contact email' text={institution.contact_email} tReg={tReg} />
      <SuggestionItem label='description' text={institution.description} tReg={tReg} />
      <SuggestionItems label='note' pathFn={getNote} list={getNotes(institution)} tReg={tReg} />
    </div>
  )
}

const getReturnText = R.cond([
  [R.path(['original_institution', 'name']), x => 'Return to ' + R.path(['original_institution', 'name'], x)],
  [R.path(['original_reseller', 'name']), x => 'Return to ' + R.path(['original_reseller', 'name'], x)],
  [R.T, R.always('Return')]
])

class Transfer extends React.PureComponent {
  state = {
    selections: [],
    isTransferLoading: false,
    isUnclaimLoading: false
  }
  onTransfer = () => {
    const institution = R.path(['state', 'selections', 0], this)
    const invoice = R.path(['props', 'invoice'], this)
    if (!(institution && R.has('_id', institution))) {
      return window.alert('No institution selected')
    }
    if (!(invoice && R.has('line_item_id', invoice))) {
      return window.alert('No invoice selected')
    }
    this.setState({isTransferLoading: true})
    const url = `${AUTH_API_URL}/xero_invoice_items/${invoice.line_item_id}/transfer`
    sendPost(url, {institution_id: institution._id}, (errMsg) => {
      if (errMsg) {
        this.setState({isTransferLoading: false})
        return window.alert(errMsg)
      }
      // don't filter any responses
      this.setState({selections: [], isTransferLoading: false})
      this.props.onTransfer(invoice, institution)
    })
  }

  onUnclaim = () => {
    const invoice = R.path(['props', 'invoice'], this)
    if (!(invoice && R.has('line_item_id', invoice))) {
      return window.alert('No invoice selected')
    }
    const url = `${AUTH_API_URL}/xero_invoice_items/${invoice.line_item_id}/unclaim`
    if (window.confirm('Unset this invoice?')) {
      this.setState({isUnclaimLoading: true})
      sendPost(url, {institution_id: null}, (errMsg) => {
        if (errMsg) {
          this.setState({isUnclaimLoading: false})
          return window.alert(errMsg)
        }
        // don't filter any responses
        this.setState({isUnclaimLoading: false})
        this.props.onTransfer(invoice, null)
      })
    }
  }

  onAcChange = (selections, sel) => sel && sel._id
    ? this.setState({selections: [sel]})
    : this.setState({selections: []})

  render () {
    return (
      <Form size='tiny'>
        <Form.Group>
          <Form.Field width={16}>
            <AutoComplete
              minWidth={300}
              icon='users'
              placeholder='Type to search institutions, invoice will transfer there...'
              selections={this.state.selections}
              onSelectionChange={this.onAcChange}
              getUrl={getAcUrl}
              uniqField='_id'
              mapHttpBodyToSuggestions={R.prop('results')}
              formatSelection={ formatSelection }
              formatSuggestion={ formatSuggestion }
            />
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <Form.Field width={16}>
            <Button.Group>
              <Button onClick={this.props.onCancel}>Cancel</Button>
              <Button.Or />
              <Button positive loading={this.state.isTransferLoading} onClick={this.onTransfer}>Transfer</Button>
            </Button.Group>
          </Form.Field>
        </Form.Group>
        { R.path(['invoice', 'institution_id'], this.props)
          ? (
            <Form.Group>
              <Form.Field width={16}>
                <Button size='mini' loading={this.state.isUnclaimLoading} onClick={this.onUnclaim}>{getReturnText(this.props.invoice)}</Button>
              </Form.Field>
            </Form.Group>
          )
          : null
        }
      </Form>
    )
  }
}

Transfer.propTypes = {
  invoice: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onTransfer: PropTypes.func.isRequired
}

export default Transfer



// WEBPACK FOOTER //
// ./webAdmin/views/xero/transfer.js